import Vue from 'vue'
import Router from 'vue-router'

// Containers
const TheContainer = () => import('@/containers/TheContainer')

// Views
const Dashboard = () => import('@/views/Dashboard')
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')
// Views - pages
const Login = () => import('@/views/pages/Login')
const Password = () => import('@/views/pages/Password')
const DeliveryOutboundOrders = () => import('@/views/pages/delivery/order/Outbound')
const DeliveryInboundOrders = () => import('@/views/pages/delivery/order/Inbound')
const ShowDeliveryOrder = () => import('@/views/pages/delivery/order/Show')
const UploadAuditWeight = () => import('@/views/pages/delivery/order/UploadAuditWeight')
const DeliveryAuditWeight = () => import('@/views/pages/delivery/order/AuditWeight')
const UploadDownloadLabel = () => import('@/views/pages/delivery/order/UploadDownloadLabel')
const PendingOrders = () => import('@/views/pages/delivery/pending/Index')
const EditPendingOrder = () => import('@/views/pages/delivery/pending/Edit')
const ShowPendingOrder = () => import('@/views/pages/delivery/pending/Show')
const CreatePendingOrder = () => import('@/views/pages/delivery/pending/Create')
const UploadOrder = () => import('@/views/pages/delivery/pending/Upload')

// Courier Page
const Couriers = () => import('@/views/pages/courier/Index')
const FreightComparisonTool = () => import('@/views/pages/courier/FreightComparisonTool')
const Shipments = () => import('@/views/pages/delivery/shipment/Index')
const UploadShipment = () => import('@/views/pages/delivery/shipment/Upload')
const Shippers = () => import('@/views/pages/shipper/Index')
const EditShipper = () => import('@/views/pages/shipper/Edit')
const CreateShipper = () => import('@/views/pages/shipper/Create')

// Marketplace
const MarketplaceOrders = () => import('@/views/pages/marketplace/order/Index')
const PendingAccepts = () => import('@/views/pages/marketplace/order/PendingAccept')
const OrderShipments = () => import('@/views/pages/marketplace/order/Shipment')
const UploadMarketplaceOrderAccept = () => import('@/views/pages/marketplace/order/UploadOrderAccept')
const UploadMarketplaceOrderTracking = () => import('@/views/pages/marketplace/order/UploadTracking')
const UploadMarketplaceOrderItemInfo = () => import('@/views/pages/marketplace/order/UploadItemInfo')
const UploadOrderDownloadDN = () => import('@/views/pages/marketplace/order/UploadDownloadDN')
const MarketplaceStores = () => import('@/views/pages/marketplace/store/Index')
const EditMarketplaceStore = () => import('@/views/pages/marketplace/store/Edit')
const CreateMarketplaceStore = () => import('@/views/pages/marketplace/store/Create')
const MarketplaceContactMessage = () => import('@/views/pages/marketplace/contact/Message')
const EditMarketplaceContactMessage = () => import('@/views/pages/marketplace/contact/EditMessage')
const CreateMarketplaceContactMessage = () => import('@/views/pages/marketplace/contact/CreateMessage')
const SendMarketplaceContactMessage = () => import('@/views/pages/marketplace/contact/UploadSendMessage')
const MarketplaceFaqs = () => import('@/views/pages/marketplace/faq/Index')
const EditMarketplaceFaq = () => import('@/views/pages/marketplace/faq/Edit')
const CreateMarketplaceFaq = () => import('@/views/pages/marketplace/faq/Create')
const MarketplaceRmaProducts = () => import('@/views/pages/marketplace/rma_product/Index')
const EditMarketplaceRmaProduct = () => import('@/views/pages/marketplace/rma_product/Edit')
const CreateMarketplaceRmaProduct = () => import('@/views/pages/marketplace/rma_product/Create')

const Suppliers = () => import('@/views/pages/supplier/Index')
const EditSupplier = () => import('@/views/pages/supplier/Edit')
const CreateSupplier = () => import('@/views/pages/supplier/Create')

const SupplierInvoices = () => import('@/views/pages/supplier_invoice/Index')
const EditSupplierInvoice = () => import('@/views/pages/supplier_invoice/Edit')
const CreateSupplierInvoice = () => import('@/views/pages/supplier_invoice/Create')

// Views
// Views - Components
Vue.use(Router)

const router = new Router({
  mode: 'history', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes()
})

function configRoutes () {
  return [
    {
      path: '/',
      redirect: '/dashboard',
      name: 'home',
      component: TheContainer,
      children: [
        {
          path: 'dashboard',
          name: 'dashboard',
          component: Dashboard
        },
        {
          path: '/user',
          redirect: '/dashboard',
          name: 'user',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'password',
              name: 'update_password',
              component: Password
            }
          ]
        },
        {
          path: 'delivery',
          redirect: '/delivery/order',
          name: 'delivery',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'pending',
              name: 'pending',
              redirect: '/delivery/pending',
              component: {
                render (c) { return c('router-view') }
              },
              children: [
                {
                  path: '',
                  name: 'pending_order',
                  component: PendingOrders
                },
                {
                  path: 'create',
                  name: 'order_create',
                  component: CreatePendingOrder
                },
                {
                  path: ':id/edit',
                  name: 'order_edit',
                  component: EditPendingOrder
                },
                {
                  path: 'upload',
                  name: 'order_upload',
                  component: UploadOrder
                },
                {
                  path: ':id',
                  name: 'order_show',
                  component: ShowPendingOrder
                }
              ]
            },
            {
              path: 'order',
              name: 'order',
              redirect: '/delivery/order/inbound',
              component: {
                render (c) { return c('router-view') }
              },
              children: [
                {
                  path: 'inbound',
                  name: 'inbound_list',
                  component: DeliveryInboundOrders
                },
                {
                  path: 'outbound',
                  name: 'outbound_list',
                  component: DeliveryOutboundOrders
                },
                {
                  path: 'audit-weight',
                  name: 'delivery_audit_weight',
                  component: DeliveryAuditWeight
                },
                {
                  path: 'upload-audit-weight',
                  name: 'upload_delivery_audit_weight',
                  component: UploadAuditWeight
                },
                {
                  path: 'upload-download-label',
                  name: 'upload_delivery_download_label',
                  component: UploadDownloadLabel
                },
                {
                  path: ':id',
                  name: 'order_detail',
                  component: ShowDeliveryOrder
                }
              ]
            },
            {
              path: 'shipment',
              name: 'shipment',
              redirect: '/delivery/shipment',
              component: {
                render (c) { return c('router-view') }
              },
              children: [
                {
                  path: '',
                  name: 'shipment_list',
                  component: Shipments
                },
                {
                  path: 'upload',
                  name: 'shipment_upload',
                  component: UploadShipment
                },
              ]
            }
          ]
        },
        {
          path: 'marketplace',
          redirect: '/marketplace/order',
          name: 'marketplace',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'order',
              name: 'marketplace_order',
              redirect: '/marketplace/order',
              component: {
                render (c) { return c('router-view') }
              },
              children: [
                {
                  path: '',
                  name: 'marketplace_order_list',
                  component: MarketplaceOrders
                },
                {
                  path: 'pending-accept',
                  name: 'marketplace_pending_accept',
                  component: PendingAccepts
                },
                {
                  path: 'shipment',
                  name: 'marketplace_order_shipment',
                  component: OrderShipments
                },
                {
                  path: 'upload-accept',
                  name: 'upload_marketplace_order_accept',
                  component: UploadMarketplaceOrderAccept
                },
                {
                  path: 'upload-tracking',
                  name: 'upload_marketplace_order_tracking',
                  component: UploadMarketplaceOrderTracking
                },
                {
                  path: 'upload-item-info',
                  name: 'upload_marketplace_order_item_info',
                  component: UploadMarketplaceOrderItemInfo
                },
                {
                  path: 'upload-download-dn',
                  name: 'upload_marketplace_order_download_dn',
                  component: UploadOrderDownloadDN
                }
              ]
            },
            {
              path: 'store',
              name: 'store',
              redirect: '/marketplace/store',
              component: {
                render (c) { return c('router-view') }
              },
              children: [
                {
                  path: '',
                  name: 'store_list',
                  component: MarketplaceStores
                },
                {
                  path: 'create',
                  name: 'store_create',
                  component: CreateMarketplaceStore
                },
                {
                  path: ':id/edit',
                  name: 'store_edit',
                  component: EditMarketplaceStore
                }
              ]
            },
            {
              path: 'faq',
              name: 'faq',
              redirect: '/marketplace/faq',
              component: {
                render (c) { return c('router-view') }
              },
              children: [
                {
                  path: '',
                  name: 'faq_list',
                  component: MarketplaceFaqs
                },
                {
                  path: 'create',
                  name: 'faq_create',
                  component: CreateMarketplaceFaq
                },
                {
                  path: ':id/edit',
                  name: 'faq_edit',
                  component: EditMarketplaceFaq
                }
              ]
            },
            {
              path: 'contact',
              name: 'contact_meesage',
              redirect: '/marketplace/contact',
              component: {
                render (c) { return c('router-view') }
              },
              children: [
                {
                  path: '',
                  name: 'contact_message_list',
                  component: MarketplaceContactMessage
                },
                {
                  path: 'create',
                  name: 'contact_message_create',
                  component: CreateMarketplaceContactMessage
                },
                {
                  path: 'upload-send',
                  name: 'contact_message_send',
                  component: SendMarketplaceContactMessage
                },
                {
                  path: ':id/edit',
                  name: 'contact_message_edit',
                  component: EditMarketplaceContactMessage
                }
              ]
            }
          ]
        },
        {
          path: 'rma-product',
          name: 'rma_product',
          redirect: '/rma-product',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              name: 'rma_product_list',
              component: MarketplaceRmaProducts
            },
            {
              path: 'create',
              name: 'rma_product_create',
              component: CreateMarketplaceRmaProduct
            },
            {
              path: ':id/edit',
              name: 'rma_product_edit',
              component: EditMarketplaceRmaProduct
            }
          ]
        },
        {
          path: 'shipper',
          redirect: '/shipper',
          name: 'shipper',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              name: 'shipper_list',
              component: Shippers
            },
            {
              path: 'create',
              name: 'shipper_create',
              component: CreateShipper
            },
            {
              path: ':id/edit',
              name: 'shipper_edit',
              component: EditShipper
            }
          ]
        },
        {
          path: 'supplier',
          redirect: '/supplier',
          name: 'supplier',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              name: 'supplier_list',
              component: Suppliers
            },
            {
              path: 'create',
              name: 'supplier_create',
              component: CreateSupplier
            },
            {
              path: ':id/edit',
              name: 'supplier_edit',
              component: EditSupplier
            }
          ]
        },
        {
          path: 'supplier-invoice',
          redirect: '/supplier-invoice',
          name: 'supplier_invoice',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              name: 'supplier_invoice_list',
              component: SupplierInvoices
            },
            {
              path: 'create',
              name: 'supplier_invoice_create',
              component: CreateSupplierInvoice
            },
            {
              path: ':id/edit',
              name: 'supplier_invoice_edit',
              component: EditSupplierInvoice
            }
          ]
        },
        {
          path: 'courier',
          name: 'courier_list',
          component: Couriers
        },
        {
          path: 'freight-comparison-tool',
          name: 'freight_comparison_tool',
          component: FreightComparisonTool
        }
      ]
    },
    {
      path: '/404',
      name: 'Page404',
      component: Page404
    },
    {
      path: '/500',
      name: 'Page500',
      component: Page500
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    }
  ]
}

router.beforeEach((to, from, next) => {
  let accessToken = localStorage.getItem('access_token')
  if (accessToken || to.path === '/login' || to.path === '/register') {
    next()
  } else {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  }
})

export default router